import { Box, CircularProgress } from "@mui/material";

const Loading = ({ backColor }) => {
  if (backColor) {
    return (
      <Box
        className={`vh-100 position-absolute w-100 h-100`}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: backColor }}
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Box
      className="vh-100 position-absolute w-100 h-100 secondary-background"
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loading;
